/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Theme_DarkInputs */



/**
* | output |
* | --- |
* | "Dark" |
*
* @param {Settings_Theme_DarkInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_theme_dark = /** @type {((inputs?: Settings_Theme_DarkInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Theme_DarkInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Donker")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sombre")
	return /** @type {LocalizedString} */ ("Dark")
});